import React from 'react'
import ReactDOM from 'react-dom/client'
import '../shared/config.js'
import './client.css'
import './i18n/index.js'
import { ErrorBoundary, FallbackComponent } from './ErrorBoundary.js'
import Router from './Router.js'

window.__APP_VERSION__ = __APP_VERSION__

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <React.StrictMode>
    <ErrorBoundary fallbackComponent={FallbackComponent}>
      <Router />
    </ErrorBoundary>
  </React.StrictMode>,
)
